import { useCallback } from 'react';
import { notifyDanger } from '@gandi/notifications';
import { useTranslator } from '@gandi/translate';
export const useNotifications = () => {
  const {
    __
  } = useTranslator();
  const notifyMaybeApiError = useCallback((error, defaultMessage = __('An error has occurred. Please try again later.')) => notifyDanger({
    message:
    // $FlowFixMe[unnecessary-optional-chain]
    // $FlowFixMe[prop-missing]
    (error?.response?.data?.errors || [])[0]?.description ||
    // $FlowFixMe[unnecessary-optional-chain]
    // $FlowFixMe[prop-missing]
    error?.response?.data?.message || defaultMessage
  }), [__]);
  return {
    notifyMaybeApiError
  };
};